import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown } from 'antd';
import SensitivityLogs from '@components/aiAlerts/sensitivityControl/sensitivityLogs';
import { CSVLink } from 'react-csv';
import { summaryTableDataSelector } from '@store/aiAlerts/summary/selectors';
import { ToggleButton } from '@src/components/common/Utils/Buttons';
import ToggleIcon from '@icons/common/toggle.svg';

// eslint-disable-next-line react/display-name
export default () => {
  const [isLogsPopupOpen, setLogsPopup] = useState(false);
  const tableData = useSelector(summaryTableDataSelector);

  const getCsvData = () => {
    const csvData = [];
    for (const item of tableData) {
        csvData.push({
            AlertId: item.alertId,
            Metric: item.metricDisplayName,
            RootCause: item.rootCauseWithoutFormatting,
            Status: item.status,
            PeakSeverity: item.peakSeverity,
            ImpactedUniques: item.cumulativeImpactedUniquesRaw,
            Duration: item.duration,
            TimeAlertFired: item.eventTime
        })
    }

    return csvData;
  }

  const openLogsPopup = () => {
    setLogsPopup(true);
  };

  const closeLogsPopup = () => setLogsPopup(!isLogsPopupOpen);

  const onApply = ({ key: kebabId }:any) => {
    switch (kebabId) {
    case 'sensitivity-logs': {
      openLogsPopup();
      break;
    }
    }
  };

  const renderLogsPopup = () => (
    <SensitivityLogs
      isPopupOpen={isLogsPopupOpen}
      closePopup={closeLogsPopup}
    />
  );

  const ExportElement = (<CSVLink data={getCsvData()} filename="ai-alerts-summary.csv">Export</CSVLink>)

  const kebabItems = [{
    key: 'sensitivity-logs',
    label: 'Sensitivity Change Logs',
    disabled: false,
  },{
    key: 'ai-alert-export',
    label: ExportElement,
    disabled: false,
  }];

  return (
    <React.Fragment>
        <Dropdown
          menu={{ items: kebabItems, onClick: onApply }}
          trigger={['click']}
        >
          <ToggleButton icon={<ToggleIcon />} />
        </Dropdown>
        {isLogsPopupOpen ? renderLogsPopup() : ''}
    </React.Fragment>
  );
};
